export default ({
  data: { publishDate, updatedAt }
}) => {
  return {
    editorHeaderStatus: 'saved',
    editorHeaderUpdatedAt: updatedAt,
    editorPublishDate: publishDate
  }; 
};
